<template>
  <div class="app">
    <Card dis-hover>
      <p slot="title">
        <Icon type="ios-bookmark"></Icon> 我的考勤
      </p>

      <div class="table_body">
        <Table ref="table" border :loading="loading" :columns="columns" :no-data-text="NoDatas" :data="tableBody_item"></Table>

        <div style="margin-top: 10px;">
          <!-- <Page  show-sizer show-elevator show-total :current="current" :total="totalCount" @on-change="pageChange" @on-page-size-change="pagesizeChange"></Page> -->
        </div>
      </div>
    </Card>
  </div>
</template>
<script>
import moment from 'moment'
export default {
  name: 'mypersonholiday',
  props: {},
  components: {},
  filters: {
    formData(val) {
      return moment(val).format('YYYY-MM-DD')
    },
  },
  data() {
    return {
      totalCount: 0, //总共多少页
      current: 1, //当前第几页
      form: {
        Name: '',
        UserId: '',
        Year: '',
        SkipCount: 0, //从第几条开始爬
        MaxResultCount: 10, //一页多少条
		Query_我的考勤:true,
      },
      NoDatas: '暂无数据',
      loading: false,
      columns:  [
      		  {
      		    title: "姓名",
      		    key: "name",
      		    render: (h, params) => {
      		      return h("span", params.row.leaveUser.name);
      		    },
      		  },
        {
          title: "事业部",
          key: "causeDepartment",
          render: (h, params) => {
            return h("span", params.row.leaveUser.causeDepartment);
          },
        },
        {
          title: "部门",
          key: "department",
          render: (h, params) => {
            return h("span", params.row.leaveUser.departmentText);
          },
        },
        {
          title: "岗位",
          key: "postText",
          render: (h, params) => {
            return h("span", params.row.leaveUser.postText);
          },
        },
        {
          title: "年份",
          key: "year",
        },
        {
          title: "月份",
          key: "month",
        },
        {
          title: "考勤明细",
          align: "center",
          children: [
            { title: "合计", key: "sumCount" },
            { title: "迟到", key: "lateCount" },
            { title: "早退", key: "earlyLeaveCount" },
            { title: "未打卡", key: "noClockInCount" },
            { title: "旷工", key: "absenteeismCount" },
            { title: "其他", key: "otherCount" },
          ]
        },
      ],
      tableBody_item: [],
      fromFields: {},
    }
  },
  mounted() {
    // this.getColumns() //列表数据初始化
    this.getData()
  },
  methods: {
    //页数
    pageChange(size) {
      this.form.SkipCount = (size - 1) * this.form.MaxResultCount
      this.getData()
    },
    //每页最大条数
    pagesizeChange(size) {
      this.form.MaxResultCount = size
      this.getData()
    },
    //列表数据
    async getData() {
      this.loading = true
      let findData = await this.$Ajax.get(`/api/services/app/AttendanceRecord/GetAll?IncludeLeaveUser=${true}`,{params:this.form});
      
      this.tableBody_item = findData.data.result.items
      this.totalCount = findData.data.result.totalCount
      this.loading = false
    },

    //table 列
    getColumns() {
      this.columns = [
        {
          title: '用户名',
          key: 'name',
          render: (h, params) => {
            return h('span', params.row.leaveUser.name)
          },
        },
        {
          title: '年份',
          key: 'year',
          width: '80px',
        },
        {
          title: '年假天数',
          key: 'annualLeave',
        },
        {
          title: '年假已用天数',
          key: 'annualLeaveUsed',
        },
        {
          title: '年假剩余天数',
          key: 'timeRemainingAllnual',
        },
         {
          title: '年假过期日期',
          key: 'expirationTime',
          render: (h, params) => {
            return h('span', moment(params.row.expirationTime).format('YYYY-MM-DD'))
          },
        },
        {
          title: '调休天数',
          key: 'overtimeLeave',
        },
        {
          title: '调休已用天数',
          key: 'overtimeLeaveUsed',
        },
        {
          title: '调休剩余天数',
          key: 'timeRemainingOvertime',
        },
       
      ]
    },
  },
}
</script>

<style lang="less" scoped="scoped">
.app {
  min-width: 900px;
}
</style>
